import { z } from 'zod';

import locales from 'features/Onboarding/pages/CompanyName/locales';

const companyNameSchema = z.object({
  legalName: z.string().trim().min(1, { message: locales.legalNameRequired }),
});

export type CompanyNameSchema = z.infer<typeof companyNameSchema>;

export default companyNameSchema;
